import type { RecommendedSourceSummary } from "./types.ts"

/**
 * "Based on..." helper text under `ConfirmProjectInformationModal`'s "Use
 * recommended information" radio. `source: "lead"` has no version concept —
 * plain "current Lead information". For "proposal"/"contract", the product
 * owner's fallback rule: show the version only when it's real ("no
 * meaningful version" — `version_number` null, or `1` with nothing to
 * distinguish it from having no history at all); otherwise fall back to
 * `status_display`, which is always present.
 */
function formatRecommendedSourceSummary(
  summary: RecommendedSourceSummary
): string {
  if (summary.source === "lead") {
    return "Based on the current Lead information"
  }

  const sourceLabel = summary.source === "contract" ? "Contract" : "Proposal"
  const hasMeaningfulVersion =
    summary.version_number != null && summary.version_number > 1
  const detail = hasMeaningfulVersion
    ? `Version ${summary.version_number}`
    : summary.status_display

  return `Based on the latest ${sourceLabel} — ${detail}`
}

export { formatRecommendedSourceSummary }
